import CryptoJS from 'crypto-js'
import MD5 from 'crypto-js/md5'

export default {
  // 加密
  encrypt(word, keyStr) {
    // word, keyStr第一个参数是加密的字段名字  第二个是key值（16位）
    if (Object.prototype.toString.call(word) === '[object Object]') {
      //JSON.stringify
      word = JSON.stringify(word)
    }
    keyStr = keyStr || 'abcdefgabcdefg12'
    var key = CryptoJS.enc.Utf8.parse(keyStr) // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var srcs = CryptoJS.enc.Utf8.parse(word)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  },
  // 解密
  decrypt(word, keyStr) {
    keyStr = keyStr || 'abcdefgabcdefg12'
    var key = CryptoJS.enc.Utf8.parse(keyStr) // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },
  getMd5: (str) => MD5(str).toString(),
  base64Encode: (val) => {
    const encodedWord = CryptoJS.enc.Utf8.parse(val) // encodedWord Array object
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord) // string: 'NzUzMjI1NDE='
    return encoded
  }
}
